function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  transform: "matrix(-1 0 0 1 60 30)",
  fill: "#B8D2FF",
  r: 30
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M60 60c-16.418 0-29.806-13.301-29.806-29.709H90C90 46.7 76.612 60 60 60z",
  fill: "#005DFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M30 30c0 16.568-13.325 30-30 30V0c16.675 0 30 13.431 30 30z",
  fill: "#FF6A00"
});

function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90 60",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDkwIDYwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZWxsaXBzZSByeD0iMzAiIHJ5PSIzMCIgdHJhbnNmb3JtPSJtYXRyaXgoLTEgMCAwIDEgNjAgMzApIiBmaWxsPSIjQjhEMkZGIi8+CjxwYXRoIGQ9Ik02MCA2MEM0My41ODE4IDYwIDMwLjE5MzYgNDYuNjk4OSAzMC4xOTM2IDMwLjI5MTNIOTBDOTAgNDYuNjk4OSA3Ni42MTE5IDYwIDYwIDYwWiIgZmlsbD0iIzAwNURGRiIvPgo8cGF0aCBkPSJNMzAgMzBDMzAgNDYuNTY4NCAxNi42NzU0IDYwIDIuNjIyNjhlLTA2IDYwTDAgMEMxNi42NzU0IC03LjI4OTA1ZS0wNyAzMCAxMy40MzE0IDMwIDMwWiIgZmlsbD0iI0ZGNkEwMCIvPgo8L3N2Zz4K";
export { SvgLogo as ReactComponent };